import { render, staticRenderFns } from "./headerUploadDocs.vue?vue&type=template&id=76806ff0&scoped=true"
import script from "./headerUploadDocs.vue?vue&type=script&lang=js"
export * from "./headerUploadDocs.vue?vue&type=script&lang=js"
import style0 from "./headerUploadDocs.vue?vue&type=style&index=0&id=76806ff0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76806ff0",
  null
  
)

export default component.exports